import { ERROR_MESSAGE, ENV, DOMAIN } from "common/constants";
import { message } from "antd";

const codeMessage: {[key: number]: string} = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误，请检查服务器。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。",
};
const checkStatus = (response: Response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const errortext = codeMessage[response.status] || response.statusText;
  const error: any = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
};

/**
 * 部分早期接口不采用团队规范，兼容之
 */
export function fetchApi(method: string, url: string, data?: any) {
  let hideError = false;
  const headers: {[key: string]: string} = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
    "Access-Control-Allow-Origin": "*",
    "Domain":DOMAIN
  };
  
  if(url.includes("api/register")) {
    delete headers["Content-Type"]
  }

  if (ENV !== "pro") {
    console.log("请求地址:", url, "入参：", data);
  }
  
  // 断网情况check
  if (!navigator.onLine) {
    message.error("网络原因，请检查网络后继续！");
    return;
  }

  // 是否不处理error
  if (data && data.hideError === true) {
    hideError = true;
    delete data.hideError;
  }
  
  console.log("请求url", url)
  // 发出请求
  return fetch("/" + url, {
    method,
    credentials: "include",
    headers: {...headers},
    body: method === "post" ? (url.includes("api/register") ? data : JSON.stringify(data)) : undefined
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(value => {
    if(url.includes("initLoginData")) {
      return value
    } else if (value.result === 0 || hideError) {
      return value;
    } else if (url.includes("api/register")) {
      return value;
    } else {
      message.error(value.detail || "获取数据异常");
      return value;
    }
  })
  .catch(() => {
    message.error(ERROR_MESSAGE);
  })
}
